import React, { type ReactElement } from 'react';
import { type BuildLayoutProps } from '@/layout/types';
export function getBuildLayout(page: ReactElement) {
  return <BuildLayout data-sentry-element="BuildLayout" data-sentry-component="getBuildLayout" data-sentry-source-file="getBuildLayout.tsx">{page}</BuildLayout>;
}
export const BuildLayout = (props: BuildLayoutProps) => {
  return <div className="min-h-dvh bg-neutral" data-sentry-component="BuildLayout" data-sentry-source-file="getBuildLayout.tsx">{props.children}</div>;
};